import * as angular from "angular";
import {CommonsService} from "../services/commons-service.service";

angular
  .module('bringoz.admin.commons')
  .filter('bringozCapitalize', bringozCapitalize);


function bringozCapitalize($translate, splitService, commonsService: CommonsService) {
  return function bringozAddressFilter(string) {
    return commonsService.capitalize(string);
  };
}
